export var FormFieldType;
(function (FormFieldType) {
    FormFieldType[FormFieldType["Text"] = 0] = "Text";
    FormFieldType[FormFieldType["TextArea"] = 1] = "TextArea";
    FormFieldType[FormFieldType["Number"] = 2] = "Number";
    FormFieldType[FormFieldType["Date"] = 3] = "Date";
    FormFieldType[FormFieldType["DateTime"] = 4] = "DateTime";
    FormFieldType[FormFieldType["File"] = 5] = "File";
    FormFieldType[FormFieldType["ImageFile"] = 6] = "ImageFile";
    FormFieldType[FormFieldType["Custom"] = 7] = "Custom";
})(FormFieldType || (FormFieldType = {}));
export var FormFieldAlignment;
(function (FormFieldAlignment) {
    FormFieldAlignment["Center"] = "center";
    FormFieldAlignment["Left"] = "left";
    FormFieldAlignment["Right"] = "right";
})(FormFieldAlignment || (FormFieldAlignment = {}));
//# sourceMappingURL=types.js.map